import React, {useEffect, useState} from "react";
import {Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import { ListView } from "@progress/kendo-react-listview";
import {semcastAxios, showErrorToastMessage, showSuccessToastMessage} from "../../../Utils/Common";
import {
    DELETE_TRACKING_PIXELS, IDX_PIXELS_API, RECOUNT_API,
    SEGMENT_DELETE_API,
    SEGMENT_ID_PLACE_HOLDER,
    SUCCESS_STATUS, SUPER_ADMIN_IDX_PIXELS_LIST
} from "../../../api/constants";
import LoadOverlay from "../SharedComponents/LoadOverlay";
import {DELETE_MODE_MULTI, DELETE_MODE_SINGLE} from "../../../api/constants";
import { Button } from "@progress/kendo-react-buttons";
import "./DeleteSegments.css";

const TreeRecountSegments = (props) => {
    const selectedSegment = props.recountSegmnets.profileFormik.values.selectedSegments;
    const [visible, setVisible] = useState(props.visible);
    const [labelText, setLabelText] = useState("");
    const [pageLoader, setPageLoader] = useState(false);
    const [segmentNames, setSegmentNames] = useState([]);

    useEffect(() => {
        setSegmentNames(selectedSegment[0].objectName)
    }, [selectedSegment]);

    const recountSegments = async () => {
        setPageLoader(true);
        try {
            let response = await semcastAxios.put(RECOUNT_API.replace(SEGMENT_ID_PLACE_HOLDER, selectedSegment[0].id), { withCredentials: true});
            if (response.data.status === SUCCESS_STATUS) {
                showSuccessToastMessage("Segment Recount Initiated.", 5, props.reloadAfterRecount());

            };
        }  catch (error) {
            showErrorToastMessage("Please contact support. Segment Recount Failed With " + error, 10);
        } finally {
            setPageLoader(false);
            setVisible(false);
        }
    }



    return (
        <>
            <div id="recountSegmnets">
                {visible && (<Dialog
                    title={"Recount Segment"}
                    width={500}
                    closeIcon={false}
                    className={"dialog-standard"}
                >
                    <LoadOverlay active={pageLoader}>
                        <div style={{fontSize:"18px"}}>
                            <b>{labelText}</b>
                        </div>
                        <div
                            style={{
                                paddingTop: "0.75rem",
                                fontSize:"14px",
                                maxHeight: "20rem",
                                overflowY: "auto",
                            }}
                        >
                            <div className={"mb-3"}>Would you like to refresh the counts of the segment listed? </div>
                            <div>
                                <ul>
                                    <li>
                                        <strong>{segmentNames}</strong>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </LoadOverlay>
                    <DialogActionsBar layout={"end"}>
                        <Button
                            className={"button-standard button-white"}
                            onClick={() => {
                                props.cancelSubscriber(undefined)
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            className={"button-standard button-submit"}
                            onClick={recountSegments}
                        >
                            Yes
                        </Button>
                    </DialogActionsBar>
                </Dialog>)}
            </div>
        </>
    );
}

export default TreeRecountSegments;
